<section
  class="section-style"
  #footerSection
  (mousemove)="onFooterMouseMove($event)"
  (click)="onFooterClick($event)"
>
  <!-- NEW: cursor-following ember glow -->
  <div class="footer-glow" #footerGlow></div>
  <!-- NEW: ember sparks, rendered through Angular's own template system
       so scoped view-encapsulation styles actually apply to them -->
  <div
    class="footer-spark"
    *ngFor="let spark of sparks; trackBy: trackSparkById"
    [style]="getSparkStyle(spark)"
  ></div>
  <div
    style="
      display: flex;
      align-items: flex-start;
      justify-content: space-between;
      flex-wrap: wrap;
      position: relative;
      z-index: 1;
    "
  >
    <h3 class="logo">Angularize</h3>
    <div
      class="main"
      style="width: 80%"
      *ngIf="{ user: user$ | async, isPartner: isPartner$ | async } as auth"
    >
      <div *ngFor="let link of navLinks" class="menu-headings">
        <h6>{{ link.label }}</h6>
        <div class="menu-item" *ngFor="let item of link.menuItems">
          <a
            *ngIf="item.externalUrl"
            [href]="item.externalUrl"
            target="_blank"
            rel="noopener noreferrer"
            style="cursor: pointer"
            (click)="handleLinkClick($event, item, !!auth.user, !!auth.isPartner)"
          >
            {{ item.label }}
          </a>
          <a
            *ngIf="!item.externalUrl"
            style="cursor: pointer"
            [routerLink]="
              isRestricted(item.label, !!auth.user) ||
              isComingSoon(item.label) ||
              (isPartnerOnly(item.label) && !auth.isPartner)
                ? null
                : item.path
            "
            [queryParams]="
              isRestricted(item.label, !!auth.user) ||
              isComingSoon(item.label) ||
              (isPartnerOnly(item.label) && !auth.isPartner)
                ? null
                : item.queryParams || null
            "
            [fragment]="item.fragment"
            (click)="handleLinkClick($event, item, !!auth.user, !!auth.isPartner)"
            [ngClass]="{
              'footer-link-disabled':
                isRestricted(item.label, !!auth.user) ||
                isComingSoon(item.label) ||
                (isPartnerOnly(item.label) && !auth.isPartner),
            }"
            routerLinkActive="active-class"
          >
            {{ item.label }}
          </a>
        </div>
      </div>
    </div>
  </div>
  <!-- ── DIVIDER ── -->
  <div class="footer-divider" style="position: relative; z-index: 1;"></div>
  <!-- ── BOTTOM BAR ── -->
  <div class="footer-bottom" style="position: relative; z-index: 1;">
    <!-- Copyright -->
    <p class="footer-copy">
      © {{ currentYear }} Angularize.dev. All rights reserved.
    </p>
    <!-- Company attribution -->
    <div class="footer-brand">
      <span class="pulse-dot"></span>
      <span class="footer-brand-label">A product of</span>
      <a
        href="https://pythrust.com"
        target="_blank"
        rel="noopener noreferrer"
        class="pythrust-pill"
      >
        <span class="pythrust-monogram">P</span>
        <span class="pythrust-name">Pythrust Technologies OPC Pvt. Ltd.</span>
      </a>
    </div>
  </div>
</section>